import { SYSTEM_ROLE_CODE } from '../admin/permissions/role-codes';
import { useCurrentUser } from '../plugs/current-user';
import type { NavAccess } from './build-nav-entries';

export function useNavAccess(): NavAccess {
  const { user, permissions } = useCurrentUser();
  // Permissions still loading (null) fail open; the server enforces the real rule.
  const can = (key: string) => permissions === null || permissions.includes(key);

  return {
    isAdmin: user?.roles.includes(SYSTEM_ROLE_CODE) ?? false,
    offers: can('offer.view_all') || can('offer.prepare'),
    clients: can('client.view'),
    suppliers: can('supplier.view'),
    reservations: can('reservation.manage'),
  };
}
